<template>
  <div class="order-card-container store-box">
    <h4 class="mb-3">{{ $t("payment.paymentDetails") }}</h4>
    <b-form-radio-group
      @change="changePaymentSelect"
      class="mt-2 ml-3"
      :modelValue="paymentMethodClick"
    >
      <!-- <b-row>
        <b-form-radio value="paytm" class="mt-3" name="radio-size" size="lg">
          <h6 style="margin-top: 6px; font-size: 18px">Paytm</h6>
        </b-form-radio>
      </b-row> -->
      <!-- <b-container v-if="partnerInfo.online">
        <b-row>
          <b-form-radio
            value="CASHFREE"
            v-model="$store.state['checkout'].paymentMethodClick"
            class="mt-3"
            name="radio-size"
            size="lg"
          >
            <h6 style="margin-top: -1px; font-size: 20px">Cashfree</h6>
          </b-form-radio>
        </b-row>
      </b-container> -->
      <!-- <b-container
				v-if="
					tenantPrefernce &&
					tenantPrefernce.paymentMethod &&
					tenantPrefernce.paymentMethod.online
				"
			>
				<b-row>
					<b-form-radio
						value="STRIPE"
						class=""
						name="radio-size"
						size="lg"
					>
						<h6 style="margin-top: -1px; font-size: 20px">STRIPE</h6>
					</b-form-radio>
				</b-row>
			</b-container> -->
      <b-container
        v-if="
          tenantPrefernce &&
          tenantPrefernce.paymentMethod &&
          tenantPrefernce.paymentMethod.online
        "
      >
        <b-row>
          <b-form-radio
            :value="onlinePaymentName"
            class="mt-2"
            name="radio-size"
            size="lg"
          >
            <h6 style="margin-top: -1px; font-size: 20px">ONLINE</h6>
          </b-form-radio>
        </b-row>
      </b-container>

      <b-container
        v-if="
          tenantPrefernce &&
          tenantPrefernce.paymentMethod &&
          tenantPrefernce.paymentMethod.cod
        "
      >
        <b-row>
          <b-form-radio value="COD" class="mt-2" name="radio-size" size="lg">
            <h6 style="margin-top: -1px; font-size: 20px">ZELLE</h6>
          </b-form-radio>
        </b-row>
      </b-container>
    </b-form-radio-group>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "cart-payment",
  data() {
    return {
      selected: "",
    };
  },
  emits: ["changePaymentSelect"],
  computed: {
    ...mapState({
      paymentMethodClick: (state) => state.checkout.paymentMethodClick,
      partnerInfo: (state) => state.checkout.partnerInfo,
      tenantPrefernce: (state) => state.home.tenantPrefernce,
      paymentConfig: (state) => state.home.paymentConfig,
    }),
    onlinePaymentName() {
      let name = "";
      if (this.paymentConfig && Object.keys(this.paymentConfig).length)
        Object.keys(this.paymentConfig).forEach((el) => {
          if (
            this.paymentConfig[el] &&
            this.paymentConfig[el].isDefault &&
            this.paymentConfig[el].enabled
          )
            name = el.toUpperCase();
        });
      return name;
    },
  },

  methods: {
    async changePaymentSelect(res) {
      try {
        this.$store.dispatch("checkout/updatePaymentClick", res);
        this.$emit("changePaymentSelect", res);
        await this.$store.dispatch("checkout/checkoutFinal");
        // this.selected = res;
      } catch (error) {
        this.$swal({
          title: "Error",
          text: error.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    },
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  mounted() {},
};
</script>
<style scoped>
.order-left {
  left: 150px;
}

.order-card-container {
  width: 100%;
}

.order-header {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 39px;
  color: #000000;
}

.list-group {
  margin-top: 15px;
  max-height: 540px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.store-box {
  padding: 12px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  margin-top: 25px;
}
h6,
h5,
h4 {
  font-size: 15px;
  font-weight: 600;
  margin-top: 2px;
}
</style>
